import useSWR, { mutate } from 'swr';
import type { Client } from '@types';
import { fetcher } from '@/utils/queries';

function useAccountData() {
  const baseRoute = '/api/account/';

  const getAccountData = (
    clientId?: number | null,
    avoidRevalidate?: boolean
  ) => {
    let swrKey: string | null;
    if (clientId === undefined) {
      swrKey = null;
    } else if (clientId === null) {
      swrKey = baseRoute;
    } else {
      swrKey = `${baseRoute}${clientId}`;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSWR<Client, Error>(swrKey, fetcher, {
      revalidateOnMount: !avoidRevalidate, // default is true
      revalidateOnFocus: false,
    });
  };

  const refreshAccountData = async (clientId: number) => {
    await mutate(`${baseRoute}${clientId}`);
  };

  return { getAccountData, refreshAccountData };
}

export default useAccountData;
